import { createContext, useContext } from "react";

export type Announce = (message: string) => void;

/** The single polite live region for status messages (UX-01 §8, WCAG 4.1.3). */
export const AnnouncerContext = createContext<Announce>(() => undefined);

export function useAnnounce(): Announce {
  return useContext(AnnouncerContext);
}

/**
 * Batch 26 (ruling of 20 Oct): an open modal `<dialog>` makes Chromium leave everything outside it out of the accessibility tree
 * ("activeModalDialog"), the app's live region included, so an announcement made while one is open was never spoken. Each modal
 * dialog therefore carries its own empty polite region and registers it here; `announce` writes into the top-most open one, and
 * into the app's region only when no dialog is open. Returns the unregister.
 */
export type RegisterDialogRegion = (region: HTMLElement) => () => void;

export const DialogRegionContext = createContext<RegisterDialogRegion>(() => () => undefined);
